const Identity = {
  HUMAN: 'human',
  BOT: 'bot',
};

module.exports = Identity;
